export const HOME_PAGE = '/';
export const LOGOUT_PAGE = '/logout';
export const CONTENT_PAGE = '/content';
export const SEGMENT_PAGE = '/segments';
export const NEW_SEGMENT_PAGE = '/new';
export const CREATE_SEGMENT_PAGE = '/new-segment';
export const CREATE_CONTENT_PAGE = '/new-content';
export const SCHEDULING_LANDING_PAGE = '/new-campaign';
export const ONBOARD_PAGE = '/onboard';

export const ANALYTICS_PAGE = '/analytics';
export const RESOURCES_PAGE = '/resources';

export const CAMPAIGN_LIST_PAGE = '/campaigns';
export const CREATE_JOURNEY_PAGE = '/group-campaigns';
export const PARENTEX_CAMPAIGN_PAGE = '/parentex-campaigns';
